import { createPremiumModule } from '@wix/premium-fed-sdk/@premium-module';
import { EntriIntroBiExtension } from './extensions/EntriIntroBiExtension';
import { EntriIntroDataHooksExtension } from './extensions';
import { EntriIntroModal } from './EntriIntroModal';
export const EntriIntroModalModule = createPremiumModule('entriIntroModalModule', [EntriIntroBiExtension, EntriIntroDataHooksExtension], () => ({
  SDK: {
    EntriIntroModal
  }
}));
const EntriIntroModalDataBi = EntriIntroModalModule.internals.bi;
const EntriIntroModalDataHooks = EntriIntroModalModule.internals.dataHooks;
export { EntriIntroModalDataBi, EntriIntroModalDataHooks };
//# sourceMappingURL=EntriIntroModalModule.js.map